import { z } from "zod"
import { paginationResponseType, UserRole } from "@/types";

// ============ TIPOS DE LOGIN ============
export type LoginState = {
    success?: boolean;
    message?: string;
    errors?: {
        identifier?: string[];
        password?: string[];
    };
    values?: {
        identifier: string;
        password: string;
    };
};

export type LoginType = {
    identifier: string;
    password: string;
};

export type LoginResponse = {
    success: boolean;
    message: string;
    sut25: string;
    user: {
        id: string;
        name: string;
        email: string;
        role: UserRole;
    };
};

export type LogoutResponse = {
    success: boolean;
    message: string;
};

// ============ TIPOS DE USUÁRIO ATUAL ============
export type CurrentUserResponse = {
    name: string;
    email: string;
    role: UserRole;
};

export type UserMeResponse = {
    identifier: string;
    name: string;
    email: string;
    createdAt: string;
};

export type AdminMeResponse = UserMeResponse;
export type ClientMeResponse = UserMeResponse;
export type SellerMeResponse = UserMeResponse;
export type AccountantMeResponse = UserMeResponse;

// ============ SCHEMAS ZOD ============
export const loginSchema = z.object({
    identifier: z.string()
        .min(11, "CPF/CNPJ deve ter pelo menos 11 caracteres")
        .max(14, "CPF/CNPJ não pode exceder 14 caracteres"),
    password: z.string()
        .min(6, "Senha deve ter pelo menos 6 caracteres"),
});

export type LoginFormData = z.infer<typeof loginSchema>;

// ============ TIPOS DE COOKIES ============
export type ICookieOptions = {
    httponly?: boolean;
    secure?: boolean;
    samesite?: 'lax' | 'strict' | 'none';
    path?: string;
    domain?: string;
    'max-age'?: string;
    [key: string]: string | boolean | undefined;
}

// ============ TIPOS PARA ATUALIZAÇÃO PRÓPRIA ============
export type UpdateSelfType = {
    email?: string;
    password?: string;
    confirmPassword?: string;
};

export type UpdateSelfState = {
    success?: boolean;
    message?: string;
    errors?: {
        email?: string[];
        password?: string[];
        confirmPassword?: string[];
    };
    values?: UpdateSelfType;
};

export const updateSelfSchema = z.object({
    email: z.email({ message: "Por favor, insira um e-mail válido" }).optional(),
    password: z.string().min(6, { message: "Senha deve ter pelo menos 6 caracteres" }).optional(),
    confirmPassword: z.string().min(6, { message: "As senhas não coincidem" }).optional(),
}).refine((data) => {
    if (data.password && !data.confirmPassword) {
        return false;
    }
    if (data.password && data.confirmPassword && data.password !== data.confirmPassword) {
        return false;
    }
    return true;
}, {
    message: "As senhas não coincidem",
    path: ["confirmPassword"],
});

// ============ TIPOS DE RESPOSTAS ESPECÍFICAS ============
export type ClientWithAccountantResponse = {
    id: string;
    name: string;
    email: string;
    code: string;
};

export type SellerClientsResponse = {
    data: Array<{
        id: string;
        name: string;
        email: string;
        code: string;
        createdAt: string;
    }>;
    pagination: paginationResponseType;
};

export type AccountantClientsResponse = {
    data: Array<{
        id: string;
        code: string;
        name: string;
    }>;
    pagination: paginationResponseType;
};
